import React, { useState, useEffect } from 'react';
import { Fragment } from 'react';
import Box from '../Box';
import axios from 'axios';

const AdminTaskType = (props) => {

    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
    }, []);

    const handleInputChange = (event) => {
        setFormData({ ...formData, [event.target.name]: event.target.value })
    }

    const adminTaskType = () => {
        let currentSessionData = JSON.parse(sessionStorage.getItem('sessionData'));
        if (props.method === 'NEW') {
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/taskTypes`,
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                data: formData
            };

            //add dependent data
            options.data.idContactType = props.dependentData.idContactType;

            axios(options).then(response => {
                if (response.status === 200 && response.data.error === undefined) {
                    props.methodToRefreshList();
                }
            });
        }

        if (props.method === 'EDIT') {
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/taskType`,
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                data: formData
            };

            options.data.taskTypeId = props.dependentData.id;

            axios(options).then(response => {
                if (response.status === 200 && response.data.error === null) {
                    props.methodToRefreshList();
                }
            });
        }


        if (props.method === 'DELETE') {
            const options = {
                url: `${process.env.REACT_APP_URI_API_CRM}/taskType`,
                method: 'DELETE',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json;charset=UTF-8',
                    'Authorization': currentSessionData.token
                },
                data: formData
            };

            options.data.taskTypeId = props.dependentData.id;

            axios(options).then(response => {
                if (response.status === 200 && response.data.error === null) {
                    props.methodToRefreshList();
                }
            }).catch(function (error) {
                if (error.response.status === 500 && error.response.data != null) {
                    setError('No es posible eliminar el tipo de gestión seleccionado ya que hay datos vinculados a este.');
                }
            });
        }
    }

    return (
        <Fragment>
            {props.method === 'NEW' ? (
                <Fragment>
                    <h3>Nuevo tipo de gestión</h3>
                    <p>Ingrese la descripción del tipo de gestión y haga click<br />en "Añadir".</p>
                </Fragment>
            ) : props.method === 'EDIT' ? (
                <Fragment>
                    <h3>Modificar tipo de gestión</h3>
                    <p>Modifique la descripción del tipo de gestión y haga click<br />en "Modificar".</p>
                </Fragment>
            ) : props.method === 'DELETE' ? (
                <Fragment>
                    <h3>Eliminar tipo de gestión</h3>
                    <p className="center">¿Está seguro de eliminar el tipo de gestión <b>{props.dependentData.desc}</b>?</p>
                </Fragment>
            ) : null}

            <div className="flexRow">
                {props.method === 'NEW' ? (
                    <div className="flexCol">
                        <Box type="text" name="taskTypeDesc" label="Descripción tipo de gestión" className="x3" placeholder="Ingrese nombre ..." onChange={handleInputChange}></Box>
                        <Box type="text" name="code" label="Código" className="" placeholder="Ingrese" onChange={handleInputChange}></Box>
                        <button className="collapsed default" type="button" onClick={() => adminTaskType()}>Añadir</button>
                        {/* <p>debug:{JSON.stringify(formData)}</p> */}
                    </div>
                ) : props.method === 'EDIT' ? (
                    <div className="flexCol">
                        <Box type="text" name="taskTypeDesc" label="Descripción tipo de gestión" value={props.dependentData.desc} className="x3" placeholder="Ingrese nombre ..." onChange={handleInputChange} ></Box>
                        <Box type="text" name="code" label="Código" className="" placeholder="Ingrese" onChange={handleInputChange}></Box>
                        <button className="collapsed default" type="button" onClick={() => adminTaskType()}>Modificar</button>
                    </div>
                ) : props.method === 'DELETE' ? (
                    <div className="flexCol fullWidth center">
                        <button className='aloneInRow normalHeight' type="button" onClick={() => adminTaskType()}>Si, eliminar</button>
                    </div>
                ) : null}
            </div>
            {error ? (<div className="errorWrapper">{error}</div>) : null}
        </Fragment>
    );

}

export default AdminTaskType;